export enum PlatformTypes {
    webapp = 'webapp',
    extension = 'extension',
    second_screen = 'second_screen',
    integrated = 'integrated',
    all = 'all'
}
